/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Session: The House
 */

import { Container, Row } from 'react-bootstrap'

// Components
import CardImageTop from './CardImageTop';

const TheHouse = (props) => {
    const {thehouse} = props;

    return(
        <Container>
            <Row>
                <p 
                    className="text-muted text-center mb-5"
                    data-aos="zoom-in"
                >
                    {thehouse.text}
                </p>
            </Row>
            <Row xs={1} md={2} lg={3} className="g-4">
                {thehouse.cards.map((card, idx) => {
                    return (
                        <div
                            key={idx}
                            data-aos="fade-up"
                        >
                            <CardImageTop card={card}/>
                        </div>
                    );
                })}
            </Row>
        </Container>
    );
}

export default TheHouse;